import { buildShopSeo, type ShopSeoData } from './seo'
import {
  loadHomeSeoContext,
  loadPageSeoContext,
  loadPreviewSeoContext,
  loadProductSeoContext,
} from './ssr-seo/loaders'
import { buildStaticRouteSeo } from './ssr-seo/staticRoutes'
import { createEmptySeoRouteLoadContext } from './ssr-seo/types'
import type { Route } from './types'
import type { ShopLocale } from '../i18n/shopLocale'

export const loadInitialSeoData = async (
  route: Route,
  apiBase: string,
  siteName: string,
  locale: ShopLocale,
  preloadedSettingsData?: Record<string, unknown>,
) => {
  const staticSeo = buildStaticRouteSeo(route, siteName, locale)
  if (staticSeo) return staticSeo

  const context = createEmptySeoRouteLoadContext()

  if (route.mode === 'home') {
    await loadHomeSeoContext({ apiBase, locale, preloadedSettingsData, context })
  }

  if (route.mode === 'product') {
    await loadProductSeoContext({ route, apiBase, context })
  }

  if (route.mode === 'preview') {
    await loadPreviewSeoContext({ route, apiBase, context })
  }

  if (route.mode === 'page') {
    await loadPageSeoContext({ route, apiBase, locale, context })
  }

  return buildShopSeo({
    route,
    pageData: context.pageData,
    productData: context.productData,
    categoryRouteData: context.categoryRouteData,
    homePageData: context.homePageData,
    currentPathname: context.canonicalPath,
    siteName,
    activeLocale: locale,
  })
}

export type { ShopSeoData }
